import { v4 as uuid } from 'uuid';
import { ICONS } from '@ui/icons/types';
import type { IDimensions, IWatermarkElement } from '@/types/watermarks.types';
import { WatermarkElementTypes } from '@/types/watermarks.types';

export const MAX_WATERMARK_SIZE_BYTES = 5 * 1024 * 1024;

// NaN signals not yet positioned — watermark-edit.tsx will auto-center on first render
export const DEFAULT_DIMENSIONS: IDimensions = { x: NaN, y: NaN, scale: 1, rotation: 0 };

export const DEFAULT_EMAIL_SETTINGS: IWatermarkElement['settings'] = {
  text: { font: { url: '', name: 'Inter', weight: '600' }, font_size: 48, color: '#ffffff', value: '' },
  opacity: 0.75,
  image: { original_url: '', url: '', opacity: 0.75 },
  dimensions: { ...DEFAULT_DIMENSIONS },
  repeat: false,
  duration: 'permanent',
};

export const makeDefaultElement = (): IWatermarkElement => ({
  uuid: uuid(),
  type: WatermarkElementTypes.email,
  settings: { ...DEFAULT_EMAIL_SETTINGS },
});

export const WATERMARK_OPTIONS = [
  { type: 'email', label: 'Email', icon: ICONS.EMAIL },
  { type: 'date', label: 'Date', icon: ICONS.CALENDAR2 },
  { type: 'time', label: 'Time', icon: ICONS.CLOCK },
  { type: 'datetime', label: 'Date & Time', icon: ICONS.CALENDAR_PLAY_SHOW },
  { type: 'image', label: 'Image', icon: ICONS.IMAGE },
  { type: 'custom', label: 'Custom', icon: ICONS.BRAND_TAG },
];

export const FALLBACK_VIDEO =
  import.meta.env.VITE_FALLBACK_EMBED_VIDEO ||
  'https://greenroom-static-assets.greenroom-dev.brandlive.cloud/title_templates/go-wow/api-brandlive-go-wow-segment-01.mp4';
